import { render, staticRenderFns } from "./MusicServices.vue?vue&type=template&id=77d33c50&"
import script from "./MusicServices.vue?vue&type=script&lang=ts&"
export * from "./MusicServices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports